import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block3-阅读更多.png")